
import React from 'react';
import { MessageSquare, BarChart, Database } from 'lucide-react';

const SolutionDiagram = () => {
  return (
    <div className="relative mx-auto max-w-3xl my-12 overflow-hidden">
      <div className="relative z-10 bg-white/50 backdrop-blur-sm p-8 rounded-xl border border-primary/20 shadow-lg">
        <h3 className="text-2xl font-semibold mb-8 text-center">How Our Solution Works</h3>
        
        <div className="relative">
          <div className="absolute left-[50%] top-0 bottom-0 w-0.5 bg-primary/50 -translate-x-1/2"></div>
          
          <div className="flex flex-col md:flex-row items-center mb-16 relative">
            <div className="flex-1 md:pr-10 md:text-right order-2 md:order-1">
              <h4 className="text-lg font-medium mb-2">Natural Language Query</h4>
              <p className="text-muted-foreground">Users ask questions using natural language in their favorite chat tool</p>
            </div>
            <div className="md:mx-8 my-4 md:my-0 order-1 md:order-2">
              <div className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center z-10 border-2 border-primary/30 shadow-md">
                <MessageSquare className="h-8 w-8" />
              </div>
            </div>
            <div className="flex-1 md:pl-10 order-3">
              <div className="bg-secondary/50 p-4 rounded-lg border border-secondary/80 shadow-sm">
                "What were our top-selling products last month?"
              </div>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row items-center mb-16 relative">
            <div className="flex-1 md:pr-10 md:text-right order-2 md:order-3">
              <div className="bg-secondary/50 p-4 rounded-lg border border-secondary/80 shadow-sm">
                <span className="text-sm font-mono">Processing query...</span>
                <span className="block">Translating to data warehouse query</span>
              </div>
            </div>
            <div className="md:mx-8 my-4 md:my-0 order-1">
              <div className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center z-10 border-2 border-primary/30 shadow-md">
                <Database className="h-8 w-8" />
              </div>
            </div>
            <div className="flex-1 md:pl-10 order-3 md:order-2">
              <h4 className="text-lg font-medium mb-2">Intelligent Processing</h4>
              <p className="text-muted-foreground">LLM translates the question into proper data queries</p>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row items-center relative">
            <div className="flex-1 md:pr-10 md:text-right order-2 md:order-1">
              <h4 className="text-lg font-medium mb-2">Rich Data Visualization</h4>
              <p className="text-muted-foreground">Results returned in the most appropriate format</p>
            </div>
            <div className="md:mx-8 my-4 md:my-0 order-1 md:order-2">
              <div className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center z-10 border-2 border-primary/30 shadow-md">
                <BarChart className="h-8 w-8" />
              </div>
            </div>
            <div className="flex-1 md:pl-10 order-3">
              <div className="bg-secondary/50 p-4 rounded-lg border border-secondary/80 shadow-sm flex flex-col gap-2">
                <div className="h-28 bg-white/80 rounded border border-border flex items-center justify-center">
                  <BarChart className="h-16 w-16 text-primary/60" />
                </div>
                <div className="text-sm">
                  "Here are your top 5 products from last month, with Product A leading at $45,000 in revenue..."
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute -top-20 -right-20 w-64 h-64 bg-primary/10 rounded-full filter blur-3xl"></div>
      <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-accent/10 rounded-full filter blur-3xl"></div>
    </div>
  );
};

export default SolutionDiagram;
